import { useContext, useEffect, useMemo } from 'react';

import { Typography } from 'antd';

import {
  ColSize,
  ContentSection,
  Form,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';

import { StepThreeFormContext } from '../../contexts/StepThreeForm';

import { ValidateForm } from '../../../../../../../../../shared/utils';

import './index.css';
import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';
import { DECISION_TYPE } from '../../../../../../../../../shared/interfaces';


interface PaymentMethodLifeProps {
  handleValuesChange: (value: any) => void;
}

export const PaymentMethodLife = ({
  handleValuesChange,
}: PaymentMethodLifeProps) => {
  const validateForm = new ValidateForm();

  const {
    optionsPaymentMethod,
    getPaymentMethodDefault,
    stepThreeForm,
  } = useContext(StepThreeFormContext);

  const { stepTwoForm } = useContext(StepTwoFormContext);


 const isPersonalDomestic = () => {
      const formFieldValue = stepTwoForm?.getFieldValue('personalDomestic');
      return formFieldValue === DECISION_TYPE.YES;
  };

  const initialPaymentMethod = useMemo(()=> { return getPaymentMethodDefault(); }, [getPaymentMethodDefault]);

  return (
    <Form
      formProps={{
        form: stepThreeForm,
        name: 'quotation-payment-method-form',
        onValuesChange: handleValuesChange,
      }}
    >
      <ContentSection level='h3' title='Forma de pago'>
        <RowSize>
          {isPersonalDomestic() ? (
            <ColSize size={25}>
              <SelectForm
                formProps={{
                  initialValue: initialPaymentMethod,
                  label: 'Forma de pago:',
                  name: 'paymentMethod',
                  rules: validateForm.generateRules({
                    label: 'forma de pago',
                    rules: ['required'],
                  }),
                }}
                selectProps={{
                  loading: !optionsPaymentMethod,
                  options: optionsPaymentMethod,
                }}
              />
            </ColSize>
          ) : (
            <Typography.Text>
              Deberá abonar a través del formulario F931 de AFIP.
            </Typography.Text>
          )}
        </RowSize>
      </ContentSection>
    </Form>
  );
};
